import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';

import { receiveError, receiveSuccess } from '../../../store/actions/notificationAction';
import forwarderRemote from '../../../api/forwarderRemote';
import ghaFwdConfigRemote from '../../../api/ghaFwdConfigRemote';

import ApiResponse from '../../../models/ApiResponse';
import ResponseError from '../../../models/ResponseError';
import User from '../../../models/User';
import ForwarderModel from '../../../models/ForwarderAwb';
import ForwarderAccountTable from '../../../models/ForwarderAccountTable';
import ForwarderAccountAndConfig, { InvoiceAccountType } from '../../../models/ForwarderAccountAndConfig';
import GhaFwdConfig from '../../../models/GhaFwdConfig'

import FwdAccountTable from './FwdAccountsTable';
import FwdAccountBalanceDialogContainer from './FwdAccountBalanceDialogContainer';
import AddNewForwarderAccount from './AddNewForwarderAccount';

const ALL: boolean= true;

interface FwdAccountsProps {
  user: User;
  receiveSuccess: Function;
  receiveError: Function;
};

interface FwdAccountsState {
  fwd: Array<ForwarderAccountTable>;
  openModal: boolean;
  fwdAccount: ForwarderAccountAndConfig,
  forwarders: Array<ForwarderModel>;
  selectFwdValue: number ;
};

class FwdAccountsContainer extends Component <FwdAccountsProps, FwdAccountsState> {

  state = {
    fwd: [],
    openModal: false,
    fwdAccount: {
      id: 0,
      name: '',
      fwdInfo : {
        address: '',
        contacts:[],
        email: ''
      },
      accountBalance: 0,
      convenience_fee_usd: 0,
      type: InvoiceAccountType.NONE,
      other_payment_allowed: 'no' as const,
      pay_by_wallet: false
    },
    forwarders: [],
    selectFwdValue: 0,
  };

  componentDidMount() {
    this.loadForwardersAccount();
    this.loadForwarder();
  };

  loadForwarder = (): void => {
    forwarderRemote.getForwarders({all: ALL, type: 'forwarder'}).then((resp: ApiResponse<Array<ForwarderModel>>) => {

      const forwarders: Array<ForwarderModel> | undefined = resp.result;
      const error: ResponseError | undefined = resp.error;

      if (forwarders) {
          this.setState({ forwarders }); 
      };

      if (error) {
        this.props.receiveError(error);
      };
    }); 
  };

  loadForwardersAccount = (): void => {
    ghaFwdConfigRemote.getForwarderInvoiceAccounts().then((resp: ApiResponse<Array<ForwarderAccountTable>>) => {
      
      const fwd: Array<ForwarderAccountTable> | undefined = resp.result;
      const error: ResponseError | undefined = resp.error;

      if (fwd) {
        this.setState({ fwd });
      };

      if (error) {
        this.props.receiveError(error);
      };
    });
  };

  changeFwdConfig = (data: ForwarderAccountAndConfig, doUpdate: boolean): void => {

    if (!doUpdate) {

      const fwdAccounts: Array<ForwarderAccountTable> = [ ...this.state.fwd ];

      for (let i = 0; i < fwdAccounts.length; i++) {

        const fat: ForwarderAccountTable = { ...fwdAccounts[i],
          fwdId: fwdAccounts[i].fwdId,
          accountBalance: fwdAccounts[i].accountBalance,
          forwarder: { ...fwdAccounts[i].forwarder },
          config: { ...fwdAccounts[i].config }
        };

        if (fat.fwdId === data.id) {

          fat.config.type = data.type;
          fwdAccounts[i] = fat;
          this.setState({ fwd: fwdAccounts });
          break;
        }
      }

      this.props.receiveError({ errorCode: '', longDescription: 'To change account type first must set balance to 0.00.' });
      return;
    }
    const pay_by_invoice_allowed: boolean = data.type === InvoiceAccountType.NONE ? false : true;
    const config: GhaFwdConfig = {
      other_payment_allowed: data.other_payment_allowed,
      type: data.type,
      convenience_fee_usd: data.convenience_fee_usd ? Number(data.convenience_fee_usd) : 0,
      pay_by_invoice_allowed,
      pay_by_wallet: false
    }
    const idFwd: number = data.id;
    ghaFwdConfigRemote.updateGhaFwdConfig(idFwd, config).then((resp: ApiResponse<boolean>) => {

      const success: boolean | undefined = resp.success;
      const error: ResponseError | undefined = resp.error;

      if (success) {
        this.loadForwardersAccount();
      };

      if (error) {
        this.props.receiveError(error);
      };
    });
  }

  openAccountBalanceDialog = (data: ForwarderAccountAndConfig): void => {
    this.setState({ openModal: true, fwdAccount: data})
  }

  handleChange = (event: any): void => {
    this.setState({ selectFwdValue: event.target.value});
  }

  createNewFwdAccount = (): void => {
    const id: number | undefined = this.state.selectFwdValue;
    if (!id) {
      return;
    };

    ghaFwdConfigRemote.createGhaFwdConfig(id).then((resp: ApiResponse<boolean>) => {

      const success: boolean | undefined = resp.success;
      const error: ResponseError | undefined = resp.error;

      if (success) {
          this.loadForwardersAccount();
      };

      if (error) {
        this.props.receiveError(error);
      }; 
    });
  };
  
  render() {

    return (
      <Fragment>
      <AddNewForwarderAccount
        items={ this.state.forwarders}
        value={ this.state.selectFwdValue }
        onChange={ this.handleChange }
        onClick={ this.createNewFwdAccount}
      />
      <FwdAccountTable 
        fwd={ this.state.fwd}
        changeFwdConfig={ this.changeFwdConfig }
        openAccountBalanceDialog={ this.openAccountBalanceDialog }
      />
      { this.state.openModal && 
       <FwdAccountBalanceDialogContainer 
        modalOpen={this.state.openModal}
        handleCloseModal={() => this.setState({openModal: false})}
        forwarder={this.state.fwdAccount}
        loadForwardersAccount={this.loadForwardersAccount}
       />
      }
      </Fragment>
    );
  };
};

const mapStateToProps = (state: any) => {
  return {
    user: state.user
  };
};

const mapDispatchToProps = (dispatch: Function) => {
  return {
    receiveError: (error: ResponseError) => dispatch(receiveError(error)),
    receiveSuccess: (msg: string) => dispatch(receiveSuccess(msg)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(FwdAccountsContainer);
